import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { LegacyDevice } from 'console/device/device';
import { UploadFirmware } from './components/upload';
import { RecommendedUpgrade } from './components/recommended-upgrade';
import { ManualUpgrade } from './components/manual-upgrade';
import { MessageComponent } from './components/messages/base';
import { MessageBetaComponent } from './components/messages/beta';
import { MessageDowngradeComponent } from './components/messages/downgrade';
import { CoolSettingsDialog, } from 'console/dialogs/cool-settings-dialog';
import { close_upgrade_dialog, fetch_get_releases_action } from './redux/action';
import { Capability } from 'console/device/device-capability';
import { BaseSettingsDialog } from 'console/dialogs/settings/base';
import { noop } from 'ts-essentials';
import { selectSelectedDeviceFields } from 'entities/device/lib';
const tabsWithoutUpload = [RecommendedUpgrade, ManualUpgrade];
const tabsWithUpload = [RecommendedUpgrade, ManualUpgrade, UploadFirmware];
export function UpgradeDialog() {
    const _fetch_get_releases_action = useAction(fetch_get_releases_action);
    // Импорт состояний
    const { open } = useAppSelector((state) => state.upgrade_soft);
    const device = useAppSelector(selectSelectedDeviceFields([
        'id',
        'capabilities',
        'device_type',
        'firmware_version',
    ]));
    useEffect(() => {
        if (open && device) {
            _fetch_get_releases_action(device.id);
        }
    }, [open]);
    const tabs = device != null &&
        (LegacyDevice.has_capability(device?.capabilities, Capability.has_z3k_settings) ||
            LegacyDevice.has_capability(device?.capabilities, Capability.has_lua_profile)) &&
        device.device_type
        ? tabsWithUpload
        : tabsWithoutUpload;
    const handlerClose = useAction(close_upgrade_dialog);
    const device_name = device?.device_type?.name ?? '';
    const render = useCallback((viewProps) => (_jsx(BaseSettingsDialog, { ...viewProps })), [BaseSettingsDialog]);
    if (device == null) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(CoolSettingsDialog, { title: "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0448\u0438\u0432\u043A\u0438", subtitle: device_name, zIndex: 1301, open: open, onRequestClose: handlerClose, render: render, tabs: tabs, 
                //@ts-ignore
                data: { device }, volatile_data: null, save_visible: false, onSave: noop }), _jsx(MessageComponent, {}), _jsx(MessageBetaComponent, { device_id: device.id }), _jsx(MessageDowngradeComponent, { device_id: device.id })] }));
}
